// 我的
export default [{ // 个人信息
  path: '/personalInfo',
  name: 'personalInfo',
  component: resolve => require(['@/views/my/personalInfo.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 我的设置
  path: '/mySettings',
  name: 'mySettings',
  component: resolve => require(['@/views/my/mySettings.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}, { // 修改密码
  path: '/changePassword',
  name: 'changePassword',
  component: resolve => require(['@/views/my/changePassword.vue'], resolve),
  meta: {
    isLoginAuthority: true // 需要登录权限才能访问
  }
}]


// WEBPACK FOOTER //
// ./src/router/my/my.js